module.exports = __webpack_public_path__ + "img/type11@3x.d9c8eafc.png";